import { render } from "./HeroiconsSolidTerminal.vue?vue&type=template&id=541615e8"
const script = {}

import exportComponent from "/srv/www/network4web/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidTerminal.vue"]])

export default __exports__